import styled from 'styled-components';
import { CheckCircle as _CheckCircle } from '@carvana/icons';

const CheckCircle = styled(_CheckCircle)`
  color: ${props => props.$green
    ? props.theme.carvana.green.primary
    : props.theme.carvana.gray.medium};
  display: flex;

  ${props => {
    const size = parseFloat(props.$size);

    return size && `
      & > svg {
        height: ${size}px;
        width: ${size}px;
      }
    `;
  }}
`;

export default CheckCircle;